import React, { Component } from 'react'
import PropTypes from 'prop-types'
import autosize from 'autosize'


const UPDATE  = 'autosize:update'
const DESTROY = 'autosize:destroy'
const RESIZED = 'autosize:resized'


export default class TextareaAutosize extends Component {

  static propTypes = {
    valueLink: PropTypes.object,
    onResize: PropTypes.func,
  }

  static defaultProps = {
    rows: 1,
  }

  componentDidMount() {
    const { onResize } = this.props

    autosize(this.textareaEl)

    if (onResize) {
      this.textareaEl.addEventListener(RESIZED, onResize)
    }
  }

  componentWillUnmount() {
    const { onResize } = this.props

    if (onResize) {
      this.textareaEl.removeEventListener(RESIZED, onResize)
    }

    this.dispatchEvent(DESTROY)
  }

  componentWillReceiveProps(nextProps) {
    if (this.getValue(nextProps) !== this.getValue(this.props)) {
      this.dispatchEvent(UPDATE, true)
    }
  }

  dispatchEvent = (EVENT_TYPE, defer) => {
    const event = document.createEvent('Event')

    event.initEvent(EVENT_TYPE, true, false)

    const dispatch = () => {
      if (this.textareaEl) {
        this.textareaEl.dispatchEvent(event)
      }
    }

    if (defer) {
      setTimeout(dispatch, 0)
    }
    else {
      dispatch()
    }
  }

  setRef = (ref) => {
    this.textareaEl = ref
  }

  getValue = ({ valueLink, value }) => valueLink ? valueLink.value : value

  render() {
    const { valueLink, ...props } = this.props

    return (
      <textarea
        ref={this.setRef}
        {...props}
        value={valueLink.value}
        onChange={valueLink.action((x, e) => e.target.value)}
      />
    )
  }
}
